<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-compare"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Versionamentos da BDGD
        </div>
      </template>
      <v-btn
        id="btn-nova-importacao-bdgd"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.replace({ name: 'Importações BDGD Histórico' });"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        NOVA IMPORTAÇÃO
      </v-btn>
      <v-text-field
        id="versionamentos-bdgd-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-4 break-search"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="versionamentos-bdgd-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhum versionamento da BDGD disponível"
      >
        <template v-slot:[`item.data_registro`]="{ item }">
          {{ item.data_registro }}
        </template>
        <template v-slot:[`item.versao`]="{ item }">
          {{ item.versao }}
        </template>
        <template v-slot:[`item.versao_ativa`]="{ item }">
          {{ item.versao_ativa }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-switch
            id="switch-versoa-ativa-bdgd"
            v-model="item.versao_ativa"
            dense
            :disabled="item.versao_ativa"
            @change="switchAtiva(item)"
          />
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

  <script>
  import dayjs from 'dayjs'
  import VersionamentoBdgdService from '@/services/VersionamentoBdgdService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    mixins: [dateFormatterMixins],

    filters: {
    },

    components: {
    },

    props: {
    },

    data () {
      return {
        search: '',
        items: [],
        headers: [
          {
            text: 'Data Registro',
            value: 'data_registro',
          },
          {
            text: 'Versão',
            value: 'versao',
          },
          {
            sortable: false,
            text: 'Versão Ativa',
            value: 'actions',
            class: 'pl-4',
          },
        ],
      }
    },

    mounted () {
      this.getVersionamentos()
    },

    methods: {
      switchAtiva (item) {
        VersionamentoBdgdService.switchAtiva(item.id)
          .then(response => {
            this.getVersionamentos()
            this.$toast.success('Versão Ativa alterada.', '', { position: 'topRight' })
          })
          .catch(_error => {
            this.$toast.error('Erro ao alterar versão ativa.', '', { position: 'topRight' })
          })
      },

      getVersionamentos () {
        VersionamentoBdgdService.get().then(response => {
          var aux = []
          response.data.versionamentos.forEach(element => {
            const obj = {
              id: element.id,
              versao: element.versao,
              versao_ativa: element.versao_ativa,
              data_registro: this.formatDate(element.data_registro),
            }
            aux.push(obj)
          })
          this.items = aux
        })
          .catch(_error => {
            this.$toast.error('Erro ao recuperar versiomentos.', '', { position: 'topRight' })
          })
          .finally(() => { this.loading = false })
      },
    },
  }
  </script>

  <style>
    @media screen and (min-width: 800px) {
      .importacoes-bdgd-table tr td:nth-child(6),
      .importacoes-bdgd-table tr td:nth-child(7) {
        white-space: nowrap !important;
      }
    }
  </style>
